import { type ReactElement, type ReactNode, useId } from 'react';

interface ProfileSectionProps {
  readonly title: string;
  readonly description?: string;
  readonly children: ReactNode;
}

/** 회원정보 한 묶음 — 넓은 화면은 왼쪽 제목·설명, 오른쪽 내용(얇은 위 선으로 나눈다). */
export const ProfileSection = ({
  title,
  description,
  children,
}: ProfileSectionProps): ReactElement => {
  const headingId = useId();

  return (
    <section
      aria-labelledby={headingId}
      className="grid gap-5 border-t border-foreground/10 pt-8 md:grid-cols-[14rem_minmax(0,1fr)] md:gap-10"
    >
      <div className="flex flex-col gap-2">
        <h3 id={headingId} className="text-base font-bold">
          {title}
        </h3>
        {description !== undefined ? (
          <p className="text-sm text-muted-foreground">{description}</p>
        ) : null}
      </div>
      <div className="min-w-0">{children}</div>
    </section>
  );
};
